// Used to remove all non printable characters
const CTRL_CHARACTERS_REGEX = /[\u0000-\u001F\u007f]/gim // eslint-disable-line no-control-regex
const HTTP_SCHEME_REGEX = /^(https?:)?\/\//im
const SUPPORTED_SCHEME_REGEX = /^\w[\w+-]*:/m
const UNSUPPORTED_SCHEME_REGEX = /^(%20|\s)*(javascript|data)/im

export function isHttpUrl(url: string) {
  return HTTP_SCHEME_REGEX.test(url)
}

export function hasProperScheme(url: string) {
  return SUPPORTED_SCHEME_REGEX.test(url)
}

export function isRelativeUrl(url: string) {
  return (
    ['/', '.', '#'].find((c) => url.startsWith(c)) ||
    (!url.includes(':') && !url.startsWith('//'))
  )
}

function isUrlSupported(scheme: string) {
  return hasProperScheme(scheme) && !UNSUPPORTED_SCHEME_REGEX.test(scheme)
}

type SanitizeUrlOpts = {
  replacement?: string
}

/**
 * Strips all control characters and excludes javascript and data urls
 */
export default function sanitizeUrl(
  url?: string | null,
  {replacement}: SanitizeUrlOpts = {}
) {
  if (!url) {
    return url
  }

  const sanitizedUrl = String(url).replace(CTRL_CHARACTERS_REGEX, '').trim()

  if (isRelativeUrl(sanitizedUrl) || !sanitizedUrl.includes(':')) {
    return sanitizedUrl
  }

  if (!isUrlSupported(sanitizedUrl)) {
    return replacement
  }

  return sanitizedUrl
}

/**
 * This method is used for user-entered URLs and ensures that url always starts with http:
 */
export function ensureHttpUrl(url?: string | null) {
  const sanitizedUrl = sanitizeUrl(url)
  return !sanitizedUrl || isHttpUrl(sanitizedUrl)
    ? sanitizedUrl
    : 'http://' + sanitizedUrl
}
